export default __webpack_public_path__ + "static/media/14.c20e015d.png";